/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Col } from 'antd';

function hasRenderableChildren(children) {
  return React.Children.toArray(children).length > 0;
}

function TaskFormSectionCard({ title, children }) {
  if (!hasRenderableChildren(children)) {
    return null;
  }

  if (!title) {
    return (
      <Col span={24}>
        <Card bordered={false} className="task-form-section-card">
          {children}
        </Card>
      </Col>
    );
  }

  return (
    <Col span={24}>
      <Card title={title} bordered={false} className="task-form-section-card">
        {children}
      </Card>
    </Col>
  );
}

export default TaskFormSectionCard;
